import * as angular from "angular";
import {IController} from "angular";
import {ServiceAreasServiceType} from "../../../service-areas/angular/types/service-areas-service.type";
import {ResourceSkill} from "../../../agents/types/resourceSkill.type";
import {SplitService} from "../../../commons/services/split-service.service";
import * as _ from "lodash";

export class ResourceDialogFormComponent implements IController {

  resource: any;
  isEdit: boolean;
  onCancel: Function;
  onSubmit: Function;

  public isEnableResourceAgentTypeEditing: boolean;
  public agentTypes: any;
  public locationTypes: any;
  public skillsTypes: any;
  public serviceAreaTypes: any;
  public isSupportResourcePriority: any;
  public limitingSingleTimezone: any;
  public skillOptions: any;
  public logisticsVehicleTypeIds: any;
  public canAddServiceAreasToTw: any;
  public addServiceAreasToTw: any;
  public autoUpdateAllocationBranches: any;
  public selectedTab: string;
  public tabs: string[] = ['resourceDetails', 'constraints', 'agentDetails'];
  public invalidTabs: string[] = [];
  public isBranchesChanged: boolean;
  public enableAllocationBranchSupport: boolean;
  public resourceCopy: any;


  constructor(private splitService: SplitService, private agentConstants, private planningConstants, private moment) {
  }

  $onInit() {
    this.initData();
  }

  onTimeZoneChange(zoneId) {
    this.resource.zoneId = zoneId;
  }

  onAgentTypeChange(agentType) {
    this.resource.agentType = agentType;
    this.resource.agentId = undefined;
    this.resource.requiredSkills = this.agentConstants.skillsByType[agentType];
  }

  onSkillSelect(skills) {
    this.resource.requiredSkills = skills;
  }

  onVehicleSelect(vehicle) {
    this.resource.vehicle = vehicle;
    this.resource.vehicleId = _.get(vehicle, 'id');
    this.resource.mainLogisticsVehicleId = undefined;
    this.logisticsVehicleTypeIds = _.get(vehicle, 'id') ? [vehicle.id] : [];
  }

  onLogisticsVehicleSelect(logisticsVehicle) {
    this.resource.mainLogisticsVehicleId = _.get(logisticsVehicle, 'id');
  }

  onAttachedLogisticsVehicleSelect(ids) {
    this.resource.attachedLogisticsVehicleIds = ids;
  }

  onBranchIdsChange = (branchIds) => {
    this.resource.branchIds = branchIds;
    if (this.isEdit) {
      this.resource.agentId = undefined;
    }
    this.isBranchesChanged = !!_.difference(this.resource.branchIds, this.resourceCopy.branchIds).length;
  }

  onSelectServiceAreas = (serviceAreaIds) => {
    this.resource.serviceAreaIds = serviceAreaIds;

    this.canAddServiceAreasToTw = !!_.difference(this.resource.serviceAreaIds, this.resourceCopy.serviceAreaIds).length;
  }

  onSelectCarrier(account) {
    if (account?.id !== this.resource.carrierId) {
      this.resource.agentId = undefined;
    }
    this.resource.carrierId = _.get(account, 'id');
  }

  onSelectDefaultAgent(agentBinding) {
    this.resource.agentId = _.get(agentBinding, 'id');
  }

  onEnforceLocationsChange(enforceLocations) {
    this.resource.enforceLocations = enforceLocations;
  }

  onLocationSettingsChange(locationSettings) {
    this.resource.locationSettings = locationSettings;
  }

  onTagsChange(ids) {
    this.resource.tags = ids;
  }

  onResourcePriorityChange(priority) {
    this.resource.priority = priority;
  }

  onToggleBlock() {
    this.resource.isActive = !this.resource.isActive;

    if (!this.resource.isActive) {
      this.resource.blockManualRoute = true;
      this.resource.blockPlanningRoute = true;
      this.resource.blockQuoteRoute = true;
    } else {
      this.resource.blockManualRoute = false;
      this.resource.blockPlanningRoute = false;
      this.resource.blockQuoteRoute = false;
    }
  }

  onToggleBlockResource(resourceType) {
    this.resource[resourceType] = !this.resource[resourceType];
    this.resource.isActive = !this.resource.blockManualRoute || !this.resource.blockPlanningRoute || !this.resource.blockQuoteRoute
  }

  onSelectTab(tab) {
    this.selectedTab = tab;
  }

  hasErrorsInTab(tab) {
    return this.invalidTabs.includes(tab);
  }

  submit = (form) => {
    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {
        if (!this.resource.zoneId) {
          this.resource.zoneId = this.moment.tz.guess()
        }
        this.onSubmit({
          resource: this.resource,
          addServiceAreasToTw: this.canAddServiceAreasToTw ? !!this.addServiceAreasToTw?.enabled : undefined,
          autoUpdateAllocationBranches: this.enableAllocationBranchSupport && this.isBranchesChanged ? this.autoUpdateAllocationBranches?.enabled : undefined,
        });
      } else {
        this.invalidTabs = [];
        _.forEach(this.tabs, (tab, index) => {
          if (!form[tab].$valid) {
            this.invalidTabs.push(tab);
          }
        });
        this.selectedTab = this.invalidTabs[0];
      }
    }
  }

  private initData() {
    this.selectedTab = 'resourceDetails';
    this.isEnableResourceAgentTypeEditing = this.isEdit ? this.splitService.getEnableResourceAgentTypeEditing() : true;
    this.agentTypes = this.agentConstants.types;
    this.locationTypes = this.planningConstants.locationTypes;
    this.skillsTypes = this.agentConstants.skillsByType['ServiceAgent'];
    this.serviceAreaTypes = [ServiceAreasServiceType.Planning];
    this.isSupportResourcePriority = this.splitService.getSupportResourcePriority();
    this.limitingSingleTimezone = this.splitService.getLimitingSingleTimezone();
    this.skillOptions = [ResourceSkill.Delivery, ResourceSkill.Merchandise, ResourceSkill.Order, ResourceSkill.AutonomousAgent];
    this.logisticsVehicleTypeIds = this.isEdit ? (_.get(this.resource, 'vehicle.id') ? [this.resource.vehicle.id] : []) : undefined;
    this.enableAllocationBranchSupport = this.splitService.getEnableAllocationBranchSupport();
    this.resourceCopy = angular.copy(this.resource);

    if (this.isEdit) {
      this.canAddServiceAreasToTw = false;
      this.addServiceAreasToTw = {
        enabled: false
      };
      this.autoUpdateAllocationBranches = {
        enabled: false
      };

      if (!this.resource.enforceLocations) {
        this.resource.enforceLocations = 'DEFAULT';
      }
    }

    if (this.isEdit && !_.get(this.resource, 'branchIds')) {
      this.resource.branchIds = undefined;
    }
  }

}

angular
  .module('bringoz.admin.resources')
  .component('resourceDialogForm', {
    bindings: {
      resource: '<',
      isEdit: '<?',
      onCancel: '&',
      onSubmit: '&'
    },
    template: require('./resource-dialog-form.html').default,
    controller: ResourceDialogFormComponent
  });
